import { hashHistory } from 'react-router';
import { CURRENT_USER_INFO } from '../constants/common';
import { getLocal, setLocal } from '../utils/storage';
import { isEmpty, isNotEmpty } from '../utils/util';
import { getUserInfo } from '../services/user';

/**
 * @desc 用于在Root中添加一些钩子函数: onEnter, onLeave.
 **/
// 登陆校验, 通过cookie判断用户是否登陆, 此处根据实际业务逻辑调整
export function checkLogin(nextState, replace, next) {
    const userInfo = getLocal(CURRENT_USER_INFO);
    if(window.location.hash.startsWith('#/cwhx/sy/gs')) { // 进画像概述页才掉接口
        getUserInfo().then(data => {
            if (isNotEmpty(data)) {
                setLocal(CURRENT_USER_INFO, data);
                next();
            } else {
                hashHistory.replace(`/login?callback=${encodeURIComponent(location.href)}`);
            }
        });
    } else if (isEmpty(userInfo)){
        hashHistory.replace(`/login?callback=${encodeURIComponent(location.href)}`);
    } else {
        next();
    }
}

// 离开页面时校验
export function leaveConfirm(nextLocation) {
    // TODO: 动态传入字符串
    const message = '确认要离开吗？';
    if (!this.state.isSaved) {
        return message;
    }
    // 返回 false 会继续停留当前页面，
}



// WEBPACK FOOTER //
// ./src/utils/hook.js